module.exports = __webpack_public_path__ + "static/img/5-2.765ed964.png";